import { useDebugValue, useEffect, useState } from "react";
import { parse } from "./parse";

export const useSessionStorage = (key, initialState) => {
  const [state, setState] = useState(initialState);
  useDebugValue(state);
  useEffect(() => {
    const item = sessionStorage.getItem(key);
    if (item) setState(parse(item));
  }, [key]);
  const setValue = (value) => {
    setState(value);
    sessionStorage.setItem(key, JSON.stringify(value));
  };
  return [state, setValue];
};
